var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgPerfilGreen = function SvgPerfilGreen(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5357 6C15.5357 8.90184 13.1876 11.25 10.2857 11.25C7.38389 11.25 5.03571 8.90185 5.03571 6C5.03571 3.09814 7.38389 0.75 10.2857 0.75C13.1876 0.75 15.5357 3.09815 15.5357 6ZM10.2857 15.3215C11.6652 15.3215 12.9586 14.9992 14.1228 14.4642H14.4C17.393 14.4642 19.8214 16.8928 19.8214 19.8857V21.4285C19.8214 22.434 19.0055 23.25 18 23.25H2.57143C1.566 23.25 0.75 22.434 0.75 21.4285V19.8857C0.75 16.8928 3.17852 14.4642 6.17137 14.4642H6.44928C7.61662 14.9987 8.90516 15.3215 10.2857 15.3215Z",
    stroke: "#9CF27F",
    strokeWidth: 1.5
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPerfilGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/perfilGreen.a958681a.svg";
export { ForwardRef as ReactComponent };